<!-- 合作商管理 -->
<template>
  <div class="category-management">
    <page-title :title="systemName">
      <div class="category-management__body">
        <el-table v-loading="loading" :data="table" style="width: 100%"
          :header-cell-style="{ backgroundColor: `#f7f7f7` }">
          <el-table-column>
            <template slot="header" slot-scope="scope">
              <span>
                剩余额度
              </span>
              <el-button type="text" style="color: #909399" @click="describeDialog()">
                <i class="el-icon-warning-outline" style="font-size: 16px;"></i>
              </el-button>
            </template>
            <template slot-scope="scope">
              <span>{{ isLimit == 1 ? '不限额度' : remainLimit }}</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header" slot-scope="scope">
              <span>
                授信额度
              </span>
              <el-button type="text" style="color: #909399" @click="describeDialog()">
                <i class="el-icon-warning-outline" style="font-size: 16px;"></i>
              </el-button>
            </template>
            <template slot-scope="scope">
              <span>{{ isLimit == 1 ? '不限额度' : creditLimit }}</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header" slot-scope="scope">
              <span>
                已用额度
              </span>
              <el-button type="text" style="color: #909399" @click="describeDialog()">
                <i class="el-icon-warning-outline" style="font-size: 16px;"></i>
              </el-button>
            </template>
            <template slot-scope="scope">
              <span>{{ usedLimit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button class="edit" type="text" @click="openDialog()">调整额度</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </page-title>
    <page-title title="授信流水">
      <div class="category-management__body">
        <el-row class="category-management__filter-header" :gutter="20">
          <el-col :xl="8" :span="8">
            <span>交易时间：</span>
            <el-date-picker
              style="width: 100%;"
              v-model="filter.times"
              type="datetimerange"
              range-separator="至"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
          <el-col :xl="3" :span="6">
            <el-button @click="search">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
        <el-row class="category-management__filter-header" :gutter="20">
          <el-col :xl="4" :span="6">
            <el-radio-group v-model="tradeType" size="small" @input="handleType">
              <el-radio-button :label="null">全部</el-radio-button>
              <el-radio-button :label="1">调整额度</el-radio-button>
              <el-radio-button :label="0">交易记录</el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
      
        <el-table v-loading="loading" :data="tableData" style="width: 100%; margin-top: 10px;"
          :header-cell-style="{ backgroundColor: `#f7f7f7` }">
          <el-table-column prop="createTime" label="时间"></el-table-column>
          <el-table-column prop="code" label="登记单号">
            <template slot-scope="scope">
              <span>{{ scope.row.code? scope.row.code : '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="操作类型">
            <template slot-scope="scope">
              <span>{{ scope.row.type == 1 ? '更改授信额度' : '版权登记' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="handResult" label="本次操作"></el-table-column>
          <el-table-column prop="remainLimit" label="剩余额度"></el-table-column>
          <el-table-column prop="username" label="操作员"></el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
        </el-table>
        <cus-pagination :total="total" :current-page.sync="currentPage" :page-size.sync="pageSize"
          @size-change="getList"></cus-pagination>
      </div>
    </page-title>

    <!-- 新增、修改 -->
    <el-dialog
      title="调整额度"
      :visible.sync="dialogVisible"
      width="536px"
      :before-close="cancelQuota"
      :close-on-press-escape="false"
      :close-on-click-modal="false">
      <div class="quota-box1">
        <el-radio v-model="creditType" :label="1">不限额度（适用于使用周结，月结的合作伙伴）</el-radio>
      </div>
      <div class="quota-box2">
        <el-radio v-model="creditType" :label="0">固定额度</el-radio>
        <div class="quota-box3" v-show="creditType == 0">
          <p class="flex">
            <span>当前剩余额度（元）</span>
            <span>+</span>
            <span>
              <el-input v-model="quotaForm.num" @input="clearNoNum" style="width:100px;"></el-input>
            </span>
            <span>=</span>
            <span>调整后剩余额度（元）</span>
          </p>
          <p class="flex">
            <span>{{ quotaForm.oldNum }}</span>
            <span class="el-icon-caret-bottom"></span>
            <span style="opacity:0;visibility: hidden;"><el-input v-model.trim="quotaForm.num" disabled
                                                                  style="width:100px;"></el-input></span>
            <span style="opacity:0;visibility: hidden;">=</span>
            <span>{{ quotaForm.totalNum }}</span>
          </p>
        </div>
        <el-input style="margin: 20px 0 0" type="textarea" :autosize="{ minRows: 1}" v-model="quotaForm.remark"  maxlength="200" show-word-limit
                  placeholder="备注"></el-input>
      </div>
      <div slot="footer">
        <el-button @click="cancelQuota">取 消</el-button>
        <el-button type="primary" @click="dialogConfimQuota" :loading="dialogConfimQuotaLoading">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="各金额关系说明"
      :visible.sync="outterVisible"
      width="650px"
        >
        <div>
          <div class="img">
            <img
              src="../../assets/images/partner/credit.png"
              alt=""
            />
          </div>
          <div class="des">
            <span class="des__title">
              总授信额度：
            </span>
            <span>
              丝路版权网提前授信给合作商的信用额度
            </span>
          </div>
          <div class="des">
            <span class="des__title">
              已用额度：
            </span>
            <span>
              合作商已花费的额度
            </span>
          </div>
          <div class="des">
            <span class="des__title">
              剩余额度：
            </span>
            <span>
              合作商可用于在丝路版权网登记的金额
            </span>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button :loading="loading" type="primary" @click="outterVisible = false">确定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import PageTitle from "@/components/pageTitle.vue";
import CusPagination from "@/components/cusPagination.vue";
import {accAdd} from "@/utils/number";
import {
  getPertnerDetail,
  changeCredit,
  getCreditList
} from "@/api/partner";

import { scope } from "@/config/config";
export default {
  components: {
    PageTitle,
    CusPagination,
  },
  data() {
    return {
      isLimit: 0,
      id: '',
      systemName: '',
      loading: true,
      filter: {
        times: [],
      },
      tradeType: null,
      table: [{}],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      outterVisible: false,
      dialogVisible: false,
      quotaForm: {
        num: 0,
        oldNum: 0,
        totalNum: 0,
        remark: '',
      },
      creditType: 0,
      dialogConfimQuotaLoading: false,
      remainLimit: 0,  // 剩余额度
      creditLimit: 0,  // 授信额度
      usedLimit: 0,  // 已用额度
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
  },
  methods: {
    handleType(val){
      this.getList()
    },
    // 获取授信详情
    getDetail(){
      let params = {
        id: this.id
      }
      this.$ajax.get(getPertnerDetail, params).then(res => {
        let data = res.data
        if(data.code == 200){
          this.systemName = data.data.systemName
          this.isLimit = data.data.isLimit  // 额度设置状态 0 限额 1 不限额
          this.remainLimit = data.data.remainLimit  // 剩余额度
          this.creditLimit = data.data.creditLimit  // 授信额度
          this.usedLimit = data.data.usedLimit  // 已用额度
        }
      })
    },

    // 调整额度确定
    dialogConfimQuota() {
      if (!this.quotaForm.num && this.creditType == 0) {
        return this.$message.warning('请输入额度')
      }

      if(this.quotaForm.totalNum < 0 && this.creditType == 0) {
        return this.$message.error('调整后剩余额度不能为负数')
      }


      this.dialogConfimQuotaLoading = true
      let params = {
        id: this.id,
        remark: this.quotaForm.remark,
        isLimit: this.creditType,
        count: this.quotaForm.num,
      }
      this.$ajax.get(changeCredit, params).then(res => {
        let data = res.data
        if(data.code == 200) {
          this.$message.success(`额度调整成功`)
          this.dialogConfimQuotaLoading = false
          this.cancelQuota()
          this.getList();
          this.getDetail();
        }
      }).catch(() => {
        this.dialogConfimQuotaLoading = false
      })
    },

    cancelQuota() {
      if (this.dialogConfimQuotaLoading) {
        return false
      }
      this.dialogVisible = false
      this.quotaForm = {
        num: 0,
        oldNum: 0,  //可用金额
        totalNum: 0,
        remark: ''
      }
    },
    clearNoNum(obj) {

      //修复第一个字符是小数点 的情况.
      if (obj != '' && obj.substr(0, 1) == '.') {
        obj = "";
      }
      obj = obj.replace(/^0*(0\.|[1-9])/, '$1');//解决 粘贴不生效
      obj = obj.replace(/[^-\d.]/g, "");  //清除“数字”和“.”以外的字符
      obj = obj.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      obj = obj.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      obj = obj.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
      if (obj.indexOf(".") < 0 && obj != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        if (obj.substr(0, 1) == '0' && obj.length == 2) {
          obj = obj.substr(1, obj.length);
        }
      }

      // 数值范围限制
      if (obj !== '' && obj !== '-') {
        const num = parseFloat(obj);
        if (num > 9999999) {
          obj = '9999999';
        } else if (num < -9999999) {
          obj = '-9999999';
        }
      }

      this.changeVal(obj)
    },
    describeDialog() {
      this.outterVisible = true
    },
    changeVal(value) {
      this.quotaForm.totalNum = accAdd(this.quotaForm.oldNum, value).toFixed(2)
      this.quotaForm.num = value
    },

    toDetail(row){
        this.$router.push({
            path: '/partner/partnerDetail',
            query: {
                id: row.id,
            }
        })
    },
    async getList() {
      this.loading = true;
      const params = {
        externalId: this.id,
        pageSize: this.pageSize,
        pageOn: this.currentPage,
        type: this.tradeType,  // 操作类型
        beginTime: this.filter.times[0] ? this.filter.times[0] : null,
        endTime: this.filter.times[1] ? this.filter.times[1] : null,
      };
    
      const { data } = await this.$ajax.get(getCreditList, params);
      this.tableData = data?.data?.records || [];
      this.total = data?.data?.total || 0;
      this.loading = false;
    },
    search() {
      this.getList();
    },
    reset() {
      this.filter.times = [];
      this.tradeType = null
      this.getList();
    },


    handlePageChange(page) {
      console.log("Page changed to", page);
    },
    openDialog(mode, data = {}) {
      this.dialogVisible = true
      
      // 打开页面时计算调整后的剩余额度
      this.quotaForm.oldNum = this.remainLimit
      this.creditType = this.isLimit
      this.changeVal(this.quotaForm.num)
    },
  },
  created() {
    this.id = this.$route.query.id

    this.getList();
    this.getDetail();
  },
};
</script>

<style lang="scss" scoped>
.category-management {
  .box-card {
    margin-bottom: 20px;
  }

  &__filter-header {
    display: flex;
    align-items: center;
  }

  &__body {
    .edit {
      color: #005bff;
    }

    .el-button.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }

    .el-switch__label {
      color: #333333;
    }

    .el-table {
      border: 1px solid #ebeef5;
      border-bottom: none;
      margin-bottom: 20px;
    }
  }

  .img {
    display: flex;
    width: 100%;
    justify-content: center;
    margin-bottom: 20px;
  }

  .des {
    margin-top: 10px;

    &__title {
      font-weight: 600;
    }
  }

  .el-dialog {
    .quota-box2 {
      margin: 20px 0 0;
    }

    .quota-box3 {
      margin: 20px 0;
      background: rgb(245, 245, 245);
      padding: 30px;

      > p {
        align-items: center;

        span {
          display: inline-block;
          white-space: nowrap;
          text-align: center;

          &:first-of-type {
            width: 126px;
          }

          &:nth-of-type(2n) {
            margin: 0 10px;
            width: 14px;
          }

          &:last-of-type {
            width: 140px;
            overflow: hidden;
          }
        }
      }
    }
  }
}
</style>
